import { createAsyncThunk } from '@reduxjs/toolkit';
import { WILDCARD_DOMAINS } from '@store/slices/resources';
import { getCustomDomain } from '@services/requests/wildcardDomains';

export const ThunkGetCustomDomain = createAsyncThunk(
  `${WILDCARD_DOMAINS}/getCustomDomain`,
  (_, { rejectWithValue }) => {
    try {
      return getCustomDomain();
    } catch ({ data }) {
      return rejectWithValue(data);
    }
  },
);

export default {};
